import script from "./FlyingTiger-Products.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyingTiger-Products.vue?vue&type=script&setup=true&lang=js"

import "./FlyingTiger-Products.vue?vue&type=style&index=0&id=49652070&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49652070"]])

export default __exports__